import BaseModalStore from '@src/components/modal-container/base-modal-store';
import useMount from '@src/utils/hooks/use-mount';
import AntdMessage from '@src/components/antd/message';
import { autobind } from 'core-decorators';
import { useRequest } from 'ahooks';
import { useEffect } from 'react';
import captchaHandlerDecorate from '@src/utils/captcha-deco-util';
import lockAsync from '@src/utils/lock-async';
import { computed, observable } from 'mobx';
import { noop } from '@src/utils/common-util';
import { isUndefined } from '@src/utils/type-utils';
import getUtmSource from '@src/utils/get-utm-source';
import { validPhoneRegex } from '@src/constants/regex';
import TinyInputStore from '@src/components/tiny-input/store';
// import { message } from 'antd';
import { RESERVED_STATE } from '@src/constants/business';
import message from '@src/components/common-message';
import $$tracker from '@src/tracker';

class BookModalStore extends BaseModalStore {
  $main = {};

  name = '预约弹窗';

  qrcodeSrc = require('../images/sy-qrcode.png'); // 预约二维码

  /**
   * 是否第一次预约
   * @type {boolean}
   */
  @observable isFirstAppoint = false;

  @observable closeCallback = noop;

  // 协议勾选状态
  @observable protocolCheckState = false;

  // 当前主机tab标准
  @observable channelId = 0;

  /**
   * 当前问卷类型 验证码类型（1：查询测试资格验证码，3：测试招募获得验证码，4：官网预约）
   * @type {string}
   */
  @observable type = '4';

  @computed
  get isSubscribeHasGift() {
    return this.$globalStore.isAppointmentStage && +this.$globalStore.isInSubscribeCodeTime === 1;
  }

  /**
   * 手机号码输入框
   * @type {TinyInputStore}
   */
  phoneInputStore = new TinyInputStore({
    onChange: value => {
      let val = value?.target?.value;
      if (!isUndefined(val)) {
        val = val.replace(/[^A-Za-z0-9\u4e00-\u9fa5 ]/g, '');
        // val = val.replace(/\D/g, '');
        val = val.slice(0, 11);
      }
      this.phoneInputStore.value = val;
    }
  });

  /**
   * 验证码输入框
   * @type {TinyInputStore}
   */
  smsInputStore = new TinyInputStore();

  // 立即预约提交锁
  @observable submitLock = false;

  // 预约成功回调
  @observable appointmentSuccessCallBack = noop;

  // 预约成功状态
  @observable appointmentSuccessState = false;

  // 预约成功后自动关闭的倒计时
  @observable appointmentSuccessCloseTime = 5;

  // 手机栏错误提示
  @observable phoneInputError = '';

  // 验证码栏错误提示
  @observable smsInputError = '';

  utmSource = getUtmSource();

  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }

  /**
   * 点击执行预约
   */
  @lockAsync()
  onExecuteAppointment = async () => {
    if (this.checkValidate() && !this.submitLock) {
      $$tracker.clickLjyy2();
      this.submitLock = true;
      await this.executeAppointment.run();
    }
  };

  // 预约请求发送
  appointmentAsync = () => {
    return this.$ztService.subscribeByGw({ phone: this.phoneInputStore.value, code: this.smsInputStore.value, utm_source: this.utmSource });
  };

  // 预约成功处理
  onAppointmentSuccess = data => {
    message.success('预约成功');

    this.appointmentSuccessState = true;
    const { $main } = this;

    const { is_first } = data;

    const isFirst = is_first === RESERVED_STATE.notReserved;

    this.$globalStore.authServise.setAccountInfo(this.phoneInputStore.value);

    this.isFirstAppoint = isFirst;

    this.submitLock = false;

    this.appointmentSuccessCallBack({ isFirst: this.isFirstAppoint });

    // 如果时礼包领取阶段则预约成功后弹出礼包码框
    if (!this.$globalStore.isNormalStage) {
      $main?.cdkModal?.open?.();
    }

    this.onClickClose();
  };

  /**
   * 点击修改渠道
   * @param channelId
   */
  onChangeChannel = channelId => {
    this.channelId = channelId;
  };

  /**
   * 点击同意协议状态
   */
  clickProtocol = () => {
    this.protocolCheckState = !this.protocolCheckState;
  };

  /**
   * 点击关闭弹窗
   * 重写关闭事件, 补充了弹窗特定的关闭回调
   */
  onClickClose = () => {
    this.isOpen = false;
    this.isActive = false;
    this.protocolCheckState = false;
    this.appointmentSuccessState = false;
    this.phoneInputStore.onChange('');
    this.smsInputStore.onChange('');
    this.closeCallback();
    sessionStorage.removeItem('smsFirstTimes');
    this.clearStyle();
  };

  /**
   * 校验输入
   * @returns {boolean}
   */
  checkValidate = () => {
    let validate = false;
    if (!this.phoneInputStore.value) {
      this.phoneInputError = '请输入手机号';
    } else if (!validPhoneRegex.test(this.phoneInputStore.value)) {
      this.phoneInputError = '手机格式不正确';
    } else if (!this.smsInputStore.value) {
      this.smsInputError = '请输入验证码';
    } else if (!this.protocolCheckState) {
      message.error('请先勾选同意隐私条款');
    } else {
      validate = true;
    }
    return validate;
  };

  /**
   * 发送验证码
   * @param authParams
   * @returns {Promise<boolean>}
   */
  @autobind
  @lockAsync()
  @captchaHandlerDecorate('zt')
  async onSendVCRequest({ ...authParams }) {
    $$tracker.clickYzm();
    try {
      await this.onGetPhoneCode.run({ phone: this.phoneInputStore.value, type: this.type, ...authParams });
      return true;
    } catch (err) {
      console.log(err);
      // message.error(err.message);
      return false;
    }
  }

  /**
   * 初始化数据
   */
  reInitState = () => {
    this.appointmentSuccessState = false;
    this.channelId = '';
    this.smsInputStore.onChange('');
    this.phoneInputStore.onChange('');
  };

  // 获取手机验证码
  onGetPhoneCodeAsync = params => {
    return this.$ztService.getPhoneCode(params);
  };

  @autobind
  clearSmsInputError() {
    this.smsInputError = '';
  }

  @autobind
  clearPhoneInputError() {
    this.phoneInputError = '';
  }

  use() {
    super.use();

    this.executeAppointment = useRequest(async () => await this.appointmentAsync(), {
      manual: true,
      onSuccess: data => this.onAppointmentSuccess(data),
      onError: e => {
        e.serviceResponse?.message && AntdMessage.error(e.serviceResponse?.message);
        this.submitLock = false;
      }
    });

    this.onGetPhoneCode = useRequest(async params => await this.onGetPhoneCodeAsync(params), {
      manual: true,
      onSuccess: data => {
        console.log('获取验证码', data);
      },
      onError: err => {
        err.serviceResponse?.message && AntdMessage.error(err.serviceResponse?.message);
      }
    });

    useMount(() => {
      // 二次删除重复发送状态
      sessionStorage.removeItem('smsFirstTimes');
    });

    useEffect(
      () => {
        if (!!this.phoneInputStore.value) {
          this.phoneInputError = '';
          this.smsInputError = '';
        }
      },
      [this.phoneInputStore.value]
    );

    useEffect(
      () => {
        if (!!this.smsInputStore.value) {
          this.smsInputError = '';
        }
      },
      [this.smsInputStore.value]
    );
  }
}

export default BookModalStore;
